export default "__VITE_ASSET__Ddf_NEIB__"